import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const PaymentDetails = ({ invoice, currency }) => {
  const { t } = useTranslation("coaching-portal");
  const { cost, total, unused } = invoice;
  const today = moment();
  return (
    <article className="plan-card">
      <div className="row div-small-text plan-cost-padding">
        <span>{t("membershipList.planCost")}</span>
        <span>
          {currency}
          {Number(cost).toLocaleString()}
        </span>
      </div>
      <div className="row div-small-text unused-time-padding">
        <span>
          {t("membershipList.unusedTimeAfter", {
            date: today.format("MMM D, YYYY"),
          })}
        </span>
        <span>
          {currency}
          {Number(unused * -1).toLocaleString()}
        </span>
      </div>
      <div className="row subtotal-row">
        <span className="font-bold">{t("membershipList.subtotal")}</span>
        <span className="font-bold">
          {currency}
          {Number(total).toLocaleString()}
        </span>
      </div>
    </article>
  );
};

export default PaymentDetails;
